import request from '@/utils/request'

export function selectggList () {
  return request({
    url: '/api/adinfo/USER',
    method: 'get'
  })
}

export function checkinUrl () {
  return request({
    url: '/api/applink/checkin',
    method: 'get'
  })
}
export function activityUrl () {
  return request({
    url: '/api/applink/activity',
    method: 'get'
  })
}

export function sendFeedback (data) {
  return request({
    url: '/api/syssuggest',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/API/mine.js